import React, { useRef, useState } from "react";
import { FaLinkedin, FaTwitter, FaEnvelope } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Connect = () => {
  const formRef = useRef();
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        formRef.current,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => {
          setSending(false);
          setSuccess(true);
          formRef.current.reset();
        },
        (error) => {
          setSending(false);
          setSuccess(false);
          console.error(error.text);
        }
      );
  };

  return (
    <section
      id="connect"
      className="relative py-24 px-6 md:px-20 bg-white text-black overflow-hidden"
    >
      {/* Subtle monochrome background accents */}
      <div className="absolute -top-24 -left-24 w-64 h-64 bg-black opacity-5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-24 -right-24 w-72 h-72 bg-black opacity-5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 animate-fadeIn">
          Connect & Collaborate
        </h2>
        <p className="md:text-lg mb-12 animate-fadeIn delay-200">
          Let’s shape a future that’s ambitious, accountable, and sustainable.
          Whether in ESG strategy, public speaking, or endurance sports, I’m always open to conversation.
        </p>

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="bg-white border border-black rounded-2xl shadow-md p-8 md:p-12 flex flex-col gap-6 animate-fadeIn delay-400"
        >
          <div className="flex flex-col md:flex-row gap-4">
            <input
              type="text"
              name="name"
              placeholder="Name"
              aria-label="Name"
              className="flex-1 p-4 border border-black rounded-xl focus:ring-2 focus:ring-black focus:outline-none transition"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              aria-label="Email"
              className="flex-1 p-4 border border-black rounded-xl focus:ring-2 focus:ring-black focus:outline-none transition"
              required
            />
          </div>

          <textarea
            name="message"
            placeholder="Message"
            rows="5"
            aria-label="Message"
            className="p-4 border border-black rounded-xl focus:ring-2 focus:ring-black focus:outline-none transition"
            required
          ></textarea>

          <button
            type="submit"
            className="bg-black text-white py-3 rounded-xl font-semibold hover:bg-white hover:text-black border border-black transition transform hover:scale-105 disabled:opacity-50"
            disabled={sending}
          >
            {sending ? "Sending..." : "Send Message"}
          </button>

          {/* Success / Error Message */}
          {success === true && (
            <p className="text-black mt-2">Message sent successfully!</p>
          )}
          {success === false && (
            <p className="text-black mt-2">
              Oops! Something went wrong. Try again.
            </p>
          )}

          {/* Social icons */}
          <div className="flex justify-center gap-6 mt-6 text-black">
            <a
              href="https://www.linkedin.com/in/kennethmilanzi/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition transform"
            >
              <FaLinkedin className="w-6 h-6 text-current" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-110 transition transform"
            >
              <FaTwitter className="w-6 h-6 text-current" />
            </a>
            <a
              href="mailto:milanziksr@gmail.com"
              className="hover:scale-110 transition transform"
            >
              <FaEnvelope className="w-6 h-6 text-current" />
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Connect;